import * as React from "react";

const Out = ({ size = 24, color = '#001689', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
        {...props}
    >
        <path
            fill='#161616'
            stroke={color}
            d="M7.997 1.833H8a6.17 6.17 0 0 1 5.387 3.17 6.167 6.167 0 1 1-10.912 5.741l-.018-.065a.171.171 0 0 1 .282-.142l.042.053a5.79 5.79 0 0 0 5.222 3.243 5.834 5.834 0 0 0 4.928-8.919 5.834 5.834 0 0 0-10.177.495.173.173 0 0 1-.23.078.17.17 0 0 1-.076-.23 6.17 6.17 0 0 1 5.55-3.424Zm-.664 3.331a.17.17 0 0 1 .12.05l2.66 2.66a.2.2 0 0 1 .034.053l.004.01a.17.17 0 0 1 0 .127l-.004.009a.2.2 0 0 1-.033.051l-2.66 2.662-.002.002a.17.17 0 0 1-.237 0l-.003-.003-.036-.054a.2.2 0 0 1-.014-.065q.001-.033.014-.063.013-.031.036-.055h.001l1.533-1.527.858-.855H2A.167.167 0 0 1 1.833 8 .167.167 0 0 1 2 7.833h7.604l-.858-.854-1.533-1.527a.17.17 0 0 1-.036-.183q.013-.031.036-.056a.17.17 0 0 1 .12-.049Z"
        ></path>
    </svg>
);

export default Out;
